export default __webpack_public_path__ + "static/media/96tdj4t4.9ccc8ff9.jpg";